import {useEffect} from 'react';
import {
  getElementFromSessionStorage,
  removeElementFromSessionStorage,
  setElementToSessionStorage,
} from 'app/helpers/webStorageUtility';
import {FieldValues, UseFormGetValues} from 'react-hook-form';

export const useStoreSofttickerFormDataInSessionStorage = <FormInputs extends FieldValues>(
  storeKey: string,
  getFormValues: UseFormGetValues<FormInputs>,
  callback: (data: FormInputs) => void
) => {
  useEffect(() => {
    const formDataFromStorage = getElementFromSessionStorage(storeKey);
    if (formDataFromStorage) {
      const parsedFormData = JSON.parse(formDataFromStorage);
      callback(parsedFormData);
      removeElementFromSessionStorage(storeKey);
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const data = getFormValues();
      setElementToSessionStorage(storeKey, JSON.stringify(data));
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [getFormValues]);
};
